<template>
    <div>
        <div class="flex -mx-1 mb-4">
            <div class="form-group w-1/2 pl-1 pr-16">
                <label for="location_id" class="form-label">Lokacija</label>
                <input
                    type="hidden"
                    name="location_id"
                    :value="selected_location"
                >
                <v-select
                    id="location_id"
                    :filterable="false"
                    v-model="selected_location"
                    :disabled="disableEdit()"
                    :options="location"
                    :reduce="item => item.value"
                    @input="fetchAvailableEquipment"
                    @search="locationSearch"
                >
                    <template slot="no-options">
                        Pretraživanje lokacija
                    </template>
                </v-select>
            </div>

            <div class="form-group w-1/4 px-1">
                <label for="planned_for" class="form-label">Datum zaprimanja</label>
                <datetime
                    type="datetime"
                    input-id="planned_for"
                    hidden-name="planned_for"
                    input-class="form-control mb-1"
                    :disabled="disableEdit()"
                    v-model="planned_for"
                ></datetime>
            </div>
          <div class="form-group w-1/4 px-1">
            <label for="planned_end" class="form-label">Planirani završetak</label>
            <datetime
                type="datetime"
                input-id="planned_end"
                hidden-name="planned_end"
                input-class="form-control mb-1"
                :disabled="disableEdit()"
                v-model="planned_end"
            ></datetime>
          </div>
        </div>

        <div class="flex -mx-1 mb-4">
            <div class="form-group w-1/2 pl-1 pr-16">
                <label for="company_id" class="form-label">Poduzeće</label>
                <input type="hidden" name="company_id" :value="selected_company">
                <v-select
                    id="company_id"
                    :filterable="false"
                    v-model="selected_company"
                    :disabled="true"
                    :options="company"
                    :reduce="item => item.value"
                    @input="installersSearch('', '')"
                >
                    <template slot="no-options">
                        Pretraživanje poduzeća
                    </template>
                </v-select>
            </div>

            <div class="form-group w-1/2 pl-1 pr-16">
                <label for="installer_id" class="form-label">Instalater</label>
                <input
                    type="hidden"
                    name="installer_id"
                    :value="selected_installer"
                >
                <v-select
                    id="installer_id"
                    :filterable="false"
                    v-model="selected_installer"
                    :disabled="disableInstallerSelection()"
                    :options="installer"
                    :reduce="item => item.value"
                    @input="fetchAvailableProducts"
                    @search="installersSearch"
                >
                    <template slot="no-options">
                        Pretraživanje instalatera
                    </template>
                </v-select>
            </div>
        </div>

        <div class="flex -mx-1 mb-4">
            <div class="form-group w-1/2 pl-1 pr-16">
                <label for="equipment_id" class="form-label">Uređaj za popravak</label>
                <input type="hidden" name="equipment_id" :value="selectedEquipment">
                <v-select
                    id="equipment_id"
                    v-model="selectedEquipment"
                    :disabled="disableEdit() || !selected_location"
                    :options="equipmentOnLocation"
                    :reduce="item => item.id"
                    label="label"
                    @search="fetchAvailableEquipment"
                >
                    <template slot="no-options">
                        Nema dostupne opreme
                    </template>
                </v-select>
            </div>
            <div class="form-group w-1/2 pl-1 pr-16">
                <label for="custom_status" class="form-label">Status</label>
                <input type="hidden" name="custom_status" :value="customStatus">
                <v-select
                    id="custom_status"
                    v-model="customStatus"
                    :disabled="disableEdit()"
                    :options="[
                        {
                            label: 'Dijagnostika',
                            value: 'diagnostics',
                        },
                        {
                            label: 'U tijeku',
                            value: 'in_process',
                        },
                        {
                            label: 'Zatvoreno',
                            value: 'closed',
                        },
                    ]"
                    :reduce="item => item.value"
                    label="label"
                >
                </v-select>
            </div>
        </div>

        <div class="flex -mx-1 mb-4">
            <div class="form-group w-1/2 pl-1 pr-16">
                <label for="malfunction_reason_id" class="form-label">Razlog kvara</label>
                <input type="hidden" name="malfunction_reason_id" :value="malfunctionReason">
                <v-select
                    id="malfunction_reason_id"
                    v-model="malfunctionReason"
                    :disabled="disableEdit()"
                    :options="malfunctionReasons"
                    :reduce="item => item.id"
                    label="name"
                >
                </v-select>
            </div>
        </div>


        <hr>

        <!-- SERVICES -->
        <div class="-mx-1">
            <div class="px-1 w-full">
                <h2 class="font-bold text-2xl">USLUGE</h2>
            </div>

            <div
                class="px-1 flex mt-2"
                v-if="selectedServices.length > 0"
                v-for="(service, index) in selectedServices"
                :key="index"
            >
                <div class="form-group w-1/3 pr-16">
                    <label :for="`service-${index}`" class="form-label">Odaberi uslugu</label>
                    <v-select
                        :id="`service-${index}`"
                        :filterable="true"
                        :options="services"
                        :disabled="disableEdit()"
                        :reduce="service => service.id"
                        v-model="service.value"
                        label="name"
                    >
                        <template slot="no-options">
                            Pretraživanje tipova opreme
                        </template>
                    </v-select>
                    <input type="hidden" :name="`service[${index}][value]`" :value="service.value">
                </div>
                <div class="form-group w-1/4">
                    <label :for="`service-quantity-${index}`" class="form-label">Količina</label>
                    <input type="number" class="form-control" :disabled="disableEdit()" :name="`service[${index}][quantity]`" v-model="service.quantity">
                </div>
                <div class="form-group w-1/4">
                    <label for="">&nbsp;</label>
                    <button
                        :id="`remove-service-${index}`"
                        type="button"
                        :disabled="disableEdit()"
                        class="btn btn-delete border-0 mt-2 px-2 ml-4 hover:text-primary flex"
                        @click="removeService(index)"
                    >Ukloni</button>
                </div>
            </div>
            <div class="flex w-1/5 items-center mb-1 mt-4">
                <button
                    class="btn btn-lg btn-success"
                    :disabled="disableEdit()"
                    @click.prevent="addNewService()"
                >
                    <span>Dodaj stavku</span>
                </button>
            </div>
        </div>

        <hr>

        <div class="-mx-1">
            <div class="px-1 w-full">
                <h2 class="font-bold text-2xl">REZERVNI DIJELOVI</h2>
            </div>
        </div>

        <div
            class="flex flex-wrap -mx-1 mb-4 mt-4"
            v-for="(product, index) in products"
            :key="'product-' + index"
            v-if="availableTypes"
        >
            <div class="form-group w-1/3 pl-1 pr-6">
                <label for="selected_product" class="form-label">Odaberi uređaj</label>
                <v-select
                    id="selected_product"
                    :filterable="false"
                    v-model="product['type']"
                    :disabled="disableEdit()"
                    :options="availableTypes ? availableTypes['types'] : []"
                    label="title"
                >
                    <template slot="no-options">
                        Nema rezultata
                    </template>
                </v-select>
            </div>
            <div v-if="product['type']" class="form-group w-1/6 pl-1 pr-12">
                <label :for="'quantity-'+ index" class="form-label">Unesi količinu</label>
                <input
                    type="number"
                    class="form-control"
                    :id="'quantity-'+ index"
                    :disabled="disableEdit()"
                    v-model="product['quantity']"
                    min="0"
                >
            </div>
            <div
                v-if="
                    product['type'] &&
                    !product['type'].track_quantitatively &&
                    product['quantity'] > 0"
                class="form-group w-1/6 pl-1 pr-12"
            >
                <label :for="'qr-'+ index" class="form-label">Unesi QR</label>
                <v-select
                    :id="'qr-' + index"
                    :disabled="disableEdit()"
                    :options="availableTypes ? availableTypes['equipment'][product['type'].id] : []"
                    v-model="product['selected_equipment']"
                    label="qr_code"
                >
                    <template slot="no-options">
                        Nema rezultata
                    </template>
                </v-select>

                <br>

                <button
                    class="btn btn-lg btn-success"
                    :disabled="!product['selected_equipment']"
                    @click.prevent="addEquipment(product)"
                >
                    <span>Dodaj opremu</span>
                </button>
            </div>

            <div v-if="!lessThanTwo() && !hideInstalled" class="ml-auto">
                <label :for="'remove-product-' + index" class="">&nbsp;</label>
                <button
                    :id="'remove-product-' + index"
                    type="button"
                    class="btn btn-delete border-0 my-0 py-0 px-2 hover:text-primary flex"
                    @click="removeProduct(index)"
                >Ukloni uređaj</button>
            </div>

            <div class="w-1/5" v-if="product['equipment'].length > 0 && !product['type'].track_quantitatively">
                <span>Unosi:</span><br>
                <span v-for="(qrCode, qrIndex) in product.equipment" :key="'entries-' + qrIndex">
                    <div>
                        <div class="flex flex-col">
                            <div>
                                <strong>QR:</strong> {{ qrCode.code }}
                            </div>
                            <div v-if="qrCode.serial_no != ''">
                                <strong>S/N:</strong> {{ qrCode.serial_no }}
                            </div>
                        </div>

                        <div v-if="!hideInstalled && isAbleToEdit" class="flex mt-2">
                            <button
                                class="review-link mr-2"
                                :disabled="disableEdit()"
                                @click.prevent="removeQr(index, qrIndex)"
                            >
                                Ukloni QR
                            </button>
                            <br>
                            <handle-file :name="'file-' + qrCode.code" :qr="qrCode.code"></handle-file>
                        </div>
                        <hr class="m-4">
                    </div>
                </span>
            </div>
        </div>

        <span v-for="(product, index) in products" :key="'products-' + index">
            <input
                type="hidden"
                :name="'products[' + index + '][id]'"
                :value="product['type'] ? product['type'].id : null"
            >
            <input
                type="hidden"
                :name="'products[' + index + '][quantity]'"
                :value="product['quantity']"
            >

            <input
                type="hidden"
                v-if="product['equipment'].length > 0"
                v-for="equipment in product['equipment']"
                :key="equipment.value"
                :value="equipment.value"
                :name="'products[' + index + '][equipment][]'"
            >
        </span>

        <div v-if="!hideInstalled" class="flex -mx-1 mb-4 mt-8 justify-between">
            <button
                class="btn btn-lg btn-success btn-yellow ml-1"
                :disabled="disableEdit()"
                @click.prevent="addNewProduct()"
            >
                <span>Dodaj novi artikl</span>
            </button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import { Datetime } from 'vue-datetime'
import { Settings } from 'luxon'
import axios from 'axios'

Vue.component('v-select', vSelect);
Vue.component('datetime', Datetime);
Settings.defaultLocale = 'hr'

export default {
    props: {
        services: {
            type: Array,
            required: true,
        },
        old: {
            required: false,
            default: null,
        },
        isLead: {
            type: Boolean,
            default: false,
        },
        oldProducts: {
            type: Array,
            default: () => ([]),
        },
        item: {
            type: Object,
            default: () => ({}),
        },
        malfunctionReasons: {
            type: Array,
            default: () => ([]),
        },
        selectedLocation: {
            type: Number,
            default: null,
        },
        selectedInstaller: {
            type: Number,
            default: null,
        },
        selectedCompany: {
            type: Number,
            default: null,
        },
        oldServices: {
            type: Array,
            default: () => ([]),
        },
        plannedFor: {
            type: String,
            default: null
        },
        plannedEnd: {
          type: String,
          default: null
        },
    },

    data() {
        return {
            hideInstalled: false,
            location: [],
            installer: [],
            company: [],
            products: [],
            selectedServices: [],
            selected_company: null,
            selectedEquipment: null,
            customStatus: null,
            malfunctionReason: null,
            planned_for: null,
            planned_end: null,
            itemData: null,
            selected_installer: null,
            selected_location: null,
            availableTypes: null,
            equipmentOnLocation: [],
            isAbleToEdit: true,
        }
    },

    created() {
        if (this.item.status == 'install_ready') {
            this.isAbleToEdit = false;
        }

        this.selected_installer = this.selectedInstaller;
        this.selected_location = this.selectedLocation;
        this.selected_company = this.selectedCompany;
        this.selectedServices = this.oldServices;

        this.customStatus = this.item.custom_status;
        this.malfunctionReason = this.item.malfunction_reason_id;
        this.selectedEquipment = this.item.equipment_id;
        this.planned_for = this.plannedFor;
        this.planned_end = this.plannedEnd;
        this.itemData = this.item;
        this.products = this.oldProducts;

        if (this.selected_location) {
            this.fetchAvailableEquipment();
        }

        if (this.selected_installer) {
            this.fetchAvailableProducts();
        }

        if (this.old) {
            this.selectedEquipment = new Number(this.old.equipment_id)
            this.selected_location = new Number(this.old.location_id);
            this.selected_installer = new Number(this.old.installer_id);

            if (this.selected_location) {
                this.fetchAvailableEquipment();
            }

            if (this.selected_installer) {
                this.fetchAvailableProducts();
            }

            this.selectedServices = this.old.service;

            if (this.selectedServices) {
                this.selectedServices.map((ser) => {
                    ser.value = new Number(ser.value)

                    return ser
                })
            }

            this.customStatus = this.old.custom_status
            this.malfunctionReason = this.old.malfunction_reason_id

            this.planned_for = this.old.planned_for;
            this.planned_end = this.old.planned_end;

            this.products = this.old.products;

            if (this.products) {
                this.products.map((prod) => {
                    prod.type = new Number(prod.id);

                    return prod;
                });
            }
        }

        this.initProducts();
        this.initServices();
    },

    mounted() {
        if (this.item.status == 'installed' || this.item.status == 'installed_at') {
            this.hideInstalled = true
        }

        this.locationSearch('', '')
        this.initialInstallersSearch('', '')
        this.companySearch('', '')
    },

    methods: {
        lessThanTwo() {
            return this.products.length < 2
        },

        removeProduct(index) {
            this.products.splice(index, 1)
        },

        removeService(index) {
            this.selectedServices.splice(index, 1)
        },

        initProducts() {
            if (this.products.length === 0) {
                this.addNewProduct()
            }
        },

        initServices() {
            if (this.selectedServices.length === 0) {
                this.addNewService()
            }
        },

        addNewService() {
            this.selectedServices.push({
                value: null,
                quantity: 1,
            });
        },

        addNewProduct() {
            this.products.push({
                label: '',
                quantity: 0,
                type: null,
                equipment: [],
            });
        },

        fetchAvailableProducts() {
            let locationId = this.selected_installer;

            if (!locationId) {
                return;
            }

            axios.get(route('admin.api.repair-work-order.find-repair-equipment', { location: locationId }))
                .then(response => {
                    this.availableTypes = response.data;
                })
                .catch(error => {
                    console.error(error);
                })
        },

        fetchAvailableEquipment(search = null, loading = null) {
            let locationId = this.selected_location;

            if (!locationId) {
                return;
            }

            let data = { location: locationId, search }

            if (this.selectedEquipment) {
                data['equipment'] = this.selectedEquipment
            }

            axios.get(route('admin.api.repair-work-order.find-equipment', data))
                .then(response => {
                    this.equipmentOnLocation = response.data;
                })
                .catch(error => {
                    console.error(error);
                })
        },

        locationSearch(search, loading) {
            this.isSearchLoading = true;

            fetch('/api/repair-work-order/find-locations/' + escape(search))
                .then(res => res.json())
                .then(json => {
                    this.location = json.data;
                    this.isSearchLoading = false;
                })
                .catch(err => console.warn(err));
        },

        companySearch(search, loading) {
            this.isSearchLoading = true;

            fetch('/api/search/companies/' + escape(search))
                .then(res => res.json())
                .then(json => {
                    this.company = json.data;
                    this.isSearchLoading = false;
                })
                .catch(err => console.warn(err));
        },

        installersSearch(search, loading) {
            this.isInSearchLoading = true;

            fetch('/api/search/installers/' + this.selected_company + '/' + escape(search))
                .then(res => res.json())
                .then(json => {
                    this.installer = json.data;
                    this.isInSearchLoading = false;
                })
                .catch(err => console.warn(err));
        },

        initialInstallersSearch(search, loading) {
            this.isInSearchLoading = true;
            fetch('/api/search/installers/' + this.selected_company + '/' + escape(search))
                .then(res => res.json())
                .then(json => {
                    this.installer = json.data;
                    this.isInSearchLoading = false;
                })
                .catch(err => console.warn(err));
        },

        disableEdit() {
            return !(
                    this.itemData.status == 'draft' ||
                    this.itemData.status === undefined ||
                    this.itemData.status != 'closed'
                )
        },

        disableInstallerSelection() {
            return this.disableEdit() || !this.selected_company
        },

        addEquipment(item) {
            if (item.type.id == item['selected_equipment'].product_id) {
                if (item['equipment'].length == item['quantity']) {
                    alert('Već su dodani svi QR kodovi za ' + item.type.title);
                } else if (item['equipment'].length > item['quantity']) {
                    alert('Već je dodano previše QR kodova za ' + item.type.title);
                } else if (
                    item['equipment'].length > 0 &&
                    item['equipment'].find(eq => eq.value == item['selected_equipment'].id)
                ) {
                    alert('Već je dodan uređaj ' + item['selected_equipment'].qr_code);
                } else {
                    item['equipment'].push({
                        label: item['selected_equipment'].title,
                        value: item['selected_equipment'].id,
                        code: item['selected_equipment'].qr_code,
                        serial_no: item['selected_equipment'].serial_no,
                        mac_address: item['selected_equipment'].mac_address,
                        mac_address2: item['selected_equipment'].mac_address2,
                    });
                }
            }
        },

        removeQr(index, qrIndex) {
            let qrItem = this.products[index]['equipment'][qrIndex]

            this.products[index]['equipment'].splice(qrIndex, 1);
        },
    },
}
</script>
